<div class="toolbar" fxFlex="1 0">
  <button mat-raised-button type="button" (click)="startNew()" color="accent">
    New SMS
  </button>
  &nbsp;
  <button mat-raised-button type="button" (click)="load()" color="primary">
    Refresh data
  </button>
</div>
<div class="mapping" fxFlex>
  <ng-container *ngIf="showTable">
    <ng-container *ngIf="messagesResponse$ | async as resp; else nope">
      <app-message-table
        [data]="messagesResponse$"
        [templates]="templates$ | async"
        [index]="resp?.page || 0"
        [pageSize]="resp?.length || 50"
        (onPageChange)="onPageChange($event)"
        (onSortChange)="sortChanged($event)"
      ></app-message-table>
      <ng-template #none>
        <p>No messages</p>
      </ng-template>
    </ng-container>
    <ng-template #nope>
      <p>Loading...</p>
    </ng-template>
  </ng-container>
  <form *ngIf="showForm" ng-form="form" (submit)="save()">
    <mat-form-field *ngIf="templates$ | async as templates">
      <h2>Template</h2>
      <mat-select
        matInput
        placeholder="Template"
        name="template_id"
        [(ngModel)]="editMsg.template_id"
      >
        <mat-option *ngFor="let template of templates" [value]="template.id">{{
          template.name
        }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Name</mat-label>
      <input
        matInput
        placeholder="Name"
        name="name"
        [(ngModel)]="editMsg.name"
      />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Phone</mat-label>
      <input
        matInput
        placeholder="Phone"
        name="phone"
        [(ngModel)]="editMsg.phone"
      />
    </mat-form-field>
    <p class="button-bar">
      <button mat-raised-button type="submit">Send SMS</button>
      <button mat-raised-button type="button" (click)="cancel()">Cancel</button>
    </p>
  </form>
</div>
